import dayjs from '../../../dayjs'
import { dateFormatter } from '../../../utils/DateFormatter'
import {
  CASFilenameTemplateItem,
  CASSubtypeFilenameTemplateItem,
  CASTypeFilenameTemplateItem,
} from '../classes/cas'

export const CASPackageNumber = new CASFilenameTemplateItem({
  id: 'cfe13217-d13e-49f5-bc36-a097c544b538',
  name: 'Package Number',
  help: 'Submittal Package Number',
  property: 'packageNumber',
  exampleValue: 'CS0001',
})

export const CASPackageName = new CASFilenameTemplateItem({
  id: 'dfb1cf2a-c407-4050-93db-b6c8381917dc',
  name: 'Package Name',
  help: 'Submittal Package Name',
  property: 'packageName',
  exampleValue: 'Concrete Mix Design - A6505A',
})

export const CASCreatedDate = new CASFilenameTemplateItem({
  id: '174a7128-593e-495c-a591-b98ca15bb56e',
  name: 'Submitted Date',
  help: 'Date Submittal was submitted',
  property: 'createdDate',
  exampleValue: () =>
    dateFormatter(null).file(dayjs().subtract(5, 'days').toDate()),
})

export const CASDispositionDate = new CASFilenameTemplateItem({
  id: '32327b77-2160-41ec-9754-66dfe2f214f1',
  name: 'Disposition Date',
  help: 'Date Disposition was given',
  property: 'dispositionDate',
  exampleValue: () => dateFormatter(null).file(new Date()),
})

export const CASType = new CASTypeFilenameTemplateItem({
  id: '689a4753-181e-4ba1-a000-24e32667500b',
  name: 'Submittal Type',
  help: 'Submittal Package Type',
  property: 'name',
  exampleValue: 'Concrete',
})

export const CASSubtype = new CASSubtypeFilenameTemplateItem({
  id: '9c6e3bff-2da3-4d6e-aeae-b7d7a9913964',
  name: 'Submittal Subtype',
  help: 'Submittal Package Subtype',
  property: 'name',
  exampleValue: 'Mix Design',
})

export type CASFilename =
  | typeof CASPackageNumber
  | typeof CASPackageName
  | typeof CASCreatedDate
  | typeof CASDispositionDate
  | typeof CASType
  | typeof CASSubtype
